import PropTypes from 'prop-types'

import { useSelector } from 'react-redux'
import styled from '@emotion/styled'

import CategoryListItem from '../CategoryListItem'
import { selectCategories } from '../../../../flux/selectors/categories'

const StyledList = styled.ul(() => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  width: '100%',
  height: '100%',
}))

const StyledListItem = styled.li(({ theme: { colors } }) => ({
  borderBottom: `1px solid ${colors.light_grey}`,
  padding: '0px 14px',
  cursor: 'pointer',
  '&:nth-of-type(1)': {
    borderTop: `1px solid ${colors.light_grey}`,
  },
}))

const CategoryList = ({
  selectedCategories,
  onCategoryListItemClick,
}) => {
  const categories = useSelector(selectCategories)
  return (
    <StyledList data-test="CategoryList">
      {
      categories.map(category => (
        <StyledListItem key={category}>
          <CategoryListItem
            id={category}
            onSelect={onCategoryListItemClick}
            checked={selectedCategories.includes(category)}
          >
            {category}
          </CategoryListItem>
        </StyledListItem>
      ))
    }
    </StyledList>
  )
}

CategoryList.propTypes = {
  selectedCategories: PropTypes.arrayOf(
    PropTypes.string,
  ),
  onCategoryListItemClick: PropTypes.func,
}

CategoryList.defaultProps = {
  selectedCategories: [],
  onCategoryListItemClick: () => false,
}

CategoryList.displayName = 'CategoryList'
CategoryList.whyDidYouRender = true

export default CategoryList
